<div class="create-shell mt-5">
  <section class="create-acfs">
    <div class="acfs-copy">
      <h1>แปรรูปสินค้า</h1>
      <p>บันทึกการแปรรูปสินค้าเข้าสต็อก</p>
    </div>
    <img class="acfs-new-img" src="/assets/images/empty-basket.png" alt="">
  </section>

  @if (store.businessesLoaded() && store.selectedBusinessId() == null) {
    <section class="state-band">
      <div class="empty-state">
        <i class="bi bi-exclamation-triangle text-warning fs-3 mb-2 d-block" aria-hidden="true"></i>
        <strong>กรุณาเลือกธุรกิจก่อนทำการแปรรูป</strong>
        <p><a class="fw-semibold" routerLink="/trade">กลับไปรายการซื้อ-ขาย</a></p>
      </div>
    </section>
  } @else {
    <section class="detail-card">
      <div class="business-summary" aria-label="ธุรกิจ">
        <i class="bi bi-building" aria-hidden="true"></i>
        <div>
          <div class="business-summary-title">
            แปรรูปในนามธุรกิจ <span class="fw-semibold">{{ store.selectedBusiness()?.title }}</span>
          </div>
        </div>
      </div>

      <div class="form-section">
        <div class="section-label">สินค้าต้นทาง: {{ inputProductName() || '-' }}</div>
        <div class="harvest-box">
          <small class="field-hint">
            สต็อกคงเหลือ {{ formatQuantityWithUnit(availableStock(), unit) }}
          </small>

          <div class="quantity-unit-row">
            <label class="harvest-input" for="transform-input-qty">
              <span class="ui-require">จำนวนที่ใช้แปรรูป</span>
              <input id="transform-input-qty" type="text" class="form-control" inputmode="decimal"
                     placeholder="0" [(ngModel)]="form.inputQuantity" name="inputQuantity"
                     (ngModelChange)="onInputQuantityInput()"
                     [class.is-invalid]="submitted() && (inputQuantityValue() <= 0 || inputExceedsStock())">
            </label>
            <label class="harvest-input">
              <span>หน่วย</span>
              <input type="text" class="form-control unit-readonly" [value]="unit" readonly tabindex="-1">
            </label>
          </div>

          <div class="pool-actions">
            <button type="button" class="btn btn-sm btn-outline-secondary" id="transform-input-all"
                    [disabled]="availableStock() <= 0" title="ใช้ทั้งหมดที่มีในกองนี้"
                    (click)="useAllStock()">ทั้งหมด</button>
          </div>

          @if (inputExceedsStock()) {
            <small class="invalid-feedback d-block text-danger">จำนวนที่ใช้แปรรูปเกินสต็อกที่มี</small>
          } @else if (submitted() && inputQuantityValue() <= 0) {
            <small class="invalid-feedback d-block text-danger">ต้องมากกว่า 0</small>
          }
        </div>
      </div>

      <div class="form-section">
        <div class="section-label">ผลผลิตที่ได้</div>
        <div class="harvest-box">
          <label class="harvest-input" for="transform-output-name">
            <span class="ui-require">ชื่อสินค้าที่ได้</span>
            <input id="transform-output-name" type="text" class="form-control" list="transform-output-names"
                   [(ngModel)]="form.outputProductName" name="outputProductName"
                   (ngModelChange)="onOutputProductNameInput()"
                   [class.is-invalid]="submitted() && !hasOutputProductName()">
          </label>
          <datalist id="transform-output-names">
            @for (name of outputNameSuggestions(); track name) {
              <option [value]="name"></option>
            }
          </datalist>
          <small class="field-hint">ใช้ชื่อเดิมได้ถ้าต้องการรวมกับสต็อกที่มีอยู่</small>
          @if (submitted() && !hasOutputProductName()) {
            <small class="invalid-feedback d-block text-danger">กรุณาระบุชื่อสินค้าที่ได้จากการแปรรูป</small>
          }
        </div>

        <div class="harvest-box">
          <div class="quantity-unit-row">
            <label class="harvest-input" for="transform-output-qty">
              <span class="ui-require">จำนวนที่ได้</span>
              <input id="transform-output-qty" type="text" class="form-control" inputmode="decimal"
                     placeholder="0" [(ngModel)]="form.outputQuantity" name="outputQuantity"
                     (ngModelChange)="onOutputQuantityInput()"
                     [class.is-invalid]="(submitted() && outputQuantityValue() <= 0) || outputExceedsInput()">
            </label>
            <label class="harvest-input">
              <span>หน่วย</span>
              <input type="text" class="form-control unit-readonly" [value]="unit" readonly tabindex="-1">
            </label>
          </div>
          @if (outputExceedsInput()) {
            <small class="invalid-feedback d-block text-danger">จำนวนที่ได้ต้องไม่เกินจำนวนที่ใช้แปรรูป</small>
          } @else if (submitted() && outputQuantityValue() <= 0) {
            <small class="invalid-feedback d-block text-danger">ต้องมากกว่า 0</small>
          }
          <small class="field-hint">การแปรรูปทำให้น้ำหนักลดลงเท่านั้น</small>
        </div>
      </div>

      <div class="submit-row submit-actions">
        <button type="button" class="btn btn-primary flex-grow-1" [disabled]="saving()" (click)="submit()">
          @if (saving()) {
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          }
          บันทึกการแปรรูป
        </button>
        <a class="btn btn-outline-secondary" routerLink="/trade">ยกเลิก</a>
      </div>
    </section>
  }
</div>
